import { render } from "./login.vue?vue&type=template&id=1bce31ca&scoped=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=1bce31ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1bce31ca"

export default script